module.exports = {"210181001":"东城街道","210181002":"辽滨街道","210181003":"西城街道","210181004":"新柳街道","210181005":"新城街道","210181101":"大红旗镇","210181102":"梁山镇","210181103":"公主屯镇","210181104":"兴隆镇","210181105":"前当堡镇","210181106":"大民屯镇","210181107":"大柳屯镇","210181108":"兴隆堡镇","210181109":"胡台镇","210181110":"法哈牛镇","210181111":"柳河沟镇","210181112":"高台子镇","210181113":"张家屯镇","210181114":"罗家房镇","210181115":"三道岗子镇","210181116":"东蛇山子镇","210181117":"陶家屯镇","210181118":"周坨子镇","210181119":"金五台子镇","210181120":"新农村镇","210181205":"红旗乡","210181206":"卢家屯乡","210181207":"姚堡乡","210181209":"于家窝堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210181.json
// module id = 513
// module chunks = 0